import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';

import Collapse from '../Collapse';
import View from '../../Enums';
import Header from './components/Header';
import Component from '../Component';
import styles from './styles';
import Menu from './components/Menu';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import { blackMedium, MENU_WIDTH } from '../../resources/styles';
import { withResizer } from '../../HoCs';
import { path, merge, isEmptyString, getCookie, isClientSide } from '../../utils';
import { forceLogout } from '../../services/Network';
import pages from '../../PageEnums';

class Page extends Component {

    styles = styles;

    popupMenuModes = [View.MOBILE, View.TAB];

    state = {
        menu: path(this.props, 'menu', !this.popupMenuModes.includes(this.getViewMode())),
        auth: false,
    };

    openMenuPopup = () => { };

    toggleMenu = bool => () => this.setState({ menu: bool });

    renderMenu = () => this.popupMenuModes.includes(this.getViewMode()) ?
        <Drawer BackdropProps={{ style: { backgroundColor: blackMedium.color } }}
            PaperProps={{ style: { backgroundColor: 'white', boxShadow: 'none' } }}
            open={this.state.menu} onClose={this.toggleMenu(false)} anchor='left'>
            <Menu style={{ width: MENU_WIDTH }} onClose={this.toggleMenu(false)} />
        </Drawer>
        :
        <MuiThemeProvider theme={createMuiTheme()}>
            <Collapse orientation='horizontal' in={this.state.menu}><Menu style={{ width: MENU_WIDTH }} /></Collapse>
        </MuiThemeProvider>;

    checkAuth = () => {
        if (isClientSide()) {
            console.log("confirmed client side");
            const pageKey = path(window.__SERVER_DATA__, 'openingPageKey');
            console.log("pageKey - " + pageKey);
            if (!isEmptyString(pageKey) && path(pages, `${pageKey}.isLoginRequired`, false) && isEmptyString(getCookie('user_access_token'))) {
                forceLogout();
            } else {
                this.state.auth != true && this.setState({ auth: true });
            }
        }
    }

    componentDidMount = () => this.checkAuth();

    componentDidUpdate = () => this.checkAuth();

    render = () => this.state.auth ? <div style={this.gs('container')}>
        <Header onMenuClick={this.toggleMenu(!this.state.menu)} title={this.props.title} />
        <div style={this.gs('content')}>
            {this.renderMenu()}
            <div style={{ ...this.gs('children'), overflowY: this.props.overflowY, ...this.props.contentStyle }}>
                {typeof this.props.children === 'function' ? this.props.children(this.state) : this.props.children}
            </div>
        </div>
        {path(this.props, 'renderFooter', () => {})()}
    </div> : <div />;

}

Page.propTypes = {
    overflowY: PropTypes.string,
    title: PropTypes.string,
    menu: PropTypes.bool,
    contentStyles: PropTypes.object,
}

Page.defaultProps = {
    overflowY: 'auto',
};

export default withResizer(Page);